import React, { PropsWithChildren, ReactElement } from 'react';

import { Accordion, Col, Grid, Panel, Row, Text } from 'rsuite';
import CheckIcon from '@rsuite/icons/CheckRound';
import './bucket-group-wrapper.css';

interface BucketGroupWrapperProps {
  collapsible?: boolean;
  isCompleted?: boolean;
  title: string;
}

export const BucketGroupWrapper = ({
  children,
  isCompleted,
  collapsible,
  title,
}: PropsWithChildren<BucketGroupWrapperProps>): ReactElement => {
  if (!collapsible) {
    return (
      <Panel
        bodyProps={{ style: { padding: '0px' } }}
        header={
          <Text
            size="m"
            as="h4"
            style={{ textAlign: 'left', margin: '0 -20px' }}
          >
            {title}
          </Text>
        }
      >
        {children}
      </Panel>
    );
  }

  const handleClick = (
    _: string | number | undefined,
    e: React.SyntheticEvent
  ) => {
    e.preventDefault();
  };
  return (
    <Accordion
      onSelect={handleClick}
      classPrefix="bucket-group-wrapper"
    >
      <Accordion.Panel
        header={
          <Grid>
            <Row>
              <Col xs={18}>
                <Text
                  size="md"
                  as="h5"
                  className="bucket-group-wrapper-title"
                >
                  {title}
                </Text>
              </Col>
              <Col xs={6}>
                <Text
                  align="right"
                  as="i"
                  size="sm"
                  className="bucket-group-wrapper-subtitle"
                >
                  {isCompleted ? (
                    <>
                      <CheckIcon
                        className="bucket-group-wrapper-completed-icon"
                        height={20}
                      />
                      Reporting Complete
                    </>
                  ) : (
                    'Reporting Incomplete'
                  )}
                </Text>
              </Col>
            </Row>
          </Grid>
        }
      >
        {children}
      </Accordion.Panel>
    </Accordion>
  );
};
